import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { JobUpdateRequestApi } from '@/modules/jobs/types';
import { invalidateQuery } from '@/utils/queries';

type UpdateJobParams = {
  jobId: string;
  body: JobUpdateRequestApi;
};

export const useUpdateJobMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, body }: UpdateJobParams) => {
      const { data } = await fetchClient.PUT(endpoints.job, {
        params: { path: { id: jobId } },
        body,
      });

      return data;
    },
    onSettled: (_data, _error, { jobId }) => {
      invalidateQuery(jobsQueryKeys.lists())();
      invalidateQuery(jobsQueryKeys.detail(jobId))();
    },
  });
};
